import { WrapPanelWidth } from '@fleet-beat/wrap-panel';
import { LIST_VIEW } from './list-view.enum';

export interface DocumentViewConfig {
  selectedView?: LIST_VIEW;
  grid: {
    width: string | WrapPanelWidth;
    icon: string;
  };
  smallGrid: {
    width: string | WrapPanelWidth;
    icon: string;
  };
  table: {
    width: string | WrapPanelWidth;
    icon: string;
  };
}
